export const zoomTres = 11.6;

export const indicators = {
  services: 'Services',
  areaDevelopment: 'Plot Search',
  footfall: 'Footfall',
  populationStructure: 'People',
  households: 'Households',
  residentialMarket: 'Prices',
  propertyMarket: 'Properties',
  tenantSearch: 'Companies',
  reams: 'Rent Navigator',
  retailMarketAnalysis: 'Scaling Simulation',
  retailCatchmentAnalysis: 'Catchment Analysis',
};
